import React from "react";
import { withStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Clear from "@material-ui/icons/CancelOutlined";
import { fade } from "@material-ui/core/styles/colorManipulator";

const styles = (theme) => ({
  gridActionIcons: {
    width: "100%",
    float: "right",
  },
  searchContainer: {
    display: "inline-block",
    position: "relative",
    marginRight: 10,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.AppBGColor, 0.25),
    "&:hover": {
      backgroundColor: fade(theme.HeaderBGColor, 0.15),
    },
    marginLeft: 0,
    marginTop: 2,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "100%",
    },
  },
  searchInputRoot: {
    color: "inherit",
    width: "100%",
    height: 32,
    fontSize: 14,
  },
  searchInput: {
    color: theme.iconColor,
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      "&:focus": {
        width: "100%",
      },
    },
  },
  searchIcon: {
    color: theme.iconColor,
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  clearIcon: {
    paddingRight: "5px",
  },
  iconHidden: {
    visibility: "hidden",
  },
  iconVisible: {
    visibility: "visible",
    color: theme.iconColor,
    cursor: "pointer",
    paddingRight: "5px",
  },
});
const SearchBox = (props) => {
  const { classes } = props;
  return (
    <div className={classes.gridActionIcons}>
      <span className={classes.searchContainer}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search by driver name, number or manifest number"
          classes={{
            root: classes.searchInputRoot,
            input: classes.searchInput,
          }}
          onChange={props.updateQuickFilterText}
          value={props.searchText}
          endAdornment={
            <Clear
              classes={{
                root: `${classes.clearIcon} ${
                  props.searchText
                    ? classes.iconVisible
                    : classes.iconHidden
                }`,
              }}
              onClick={() =>
                props.updateQuickFilterText({ target: { value: "" } })
              }
              display={props.searchText ? "none" : "block"}
            />
          }
        />
      </span>
    </div>
  );
};

export default withStyles(styles)(SearchBox);
